import React, {useEffect, useState} from "react";
import "./OnlineStore.scss";
import {
    LazyImage, Nav,
    OnlineAddress,
    OnlineCategories,
    OnlineOff,
    OnlineSearch,
    OnlineSlider,
    OnlineSwiper
} from "../../Components";
import {DeleteBasket, StoreOnlineData} from "./OnlineStoreService";
import {useHistory, useParams} from "react-router-dom";
import {GetBasket} from "../../Components/OnlineAddress/OnlineAddressService";
import Rodal from "rodal";
import {useDispatchBasket, useResp} from "../../hooks";
import {ProductRegal} from "../../Components/ProductRegal/ProductRegal";
import VideoSec from "../Home/Sections/VideoSec";
import AudioSec from "../Home/Sections/AudioSec";
import {CampaignList} from "../Home/Sections";
import {MyInvoiceList} from "../Home/Sections/MyInvoiceList";
import PollSec from "../Home/Sections/pollSec";
import {MultipleList} from "../Home/Sections/MultipleList";
import {CategoryRegal} from "../../Components/CategoryRegal/ProductRegal";
import HomeResponsive from "../HomeResponsive/HomeResponsive";
import ShopResponsive from "../ShopResponsive/ShopResponsive";
import {Spin} from "antd";
import DrShopHeader from "../../Components/DrShopHeader/DrShopHeader";
import Loading from "../../Components/Loading/Loading";
import ServiceSecDesktop from "../DesktopComponents/ServiceSecDesktop/ServiceSecDesktop";
import ServiceSec from "../Home/Sections/ServiceSec";

Array.prototype.sortBy = function(p) {
    return this.slice(0).sort(function(a,b) {
        return (a[p] > b[p]) ? 1 : (a[p] < b[p]) ? -1 : 0;
    });
}



function OnlineStore() {
    //hooks
    const history = useHistory();
    const { metId } = useParams();
    const setBasket = useDispatchBasket();
    const resp = useResp();

    //states
    const [land,set_land] = useState(null);
    const [showModal,set_showModal] = useState(false);
    const [existBasket,set_existBasket] = useState({});
    const [merchantId,set_merchantId] = useState({});

    useEffect(()=>{
        getOnlineStoreData()
        set_merchantId(metId)
    },[])

    const [homi, setHomi] = useState([]);



        const getOnlineStoreData = async ()=>{
            try{
                set_spin(true)
                const response = await StoreOnlineData(metId);
                set_spin(false)
                // console.log("Dart : ",response.data);
                if(response.data.length>0){
                    let sorted = response.data.sortBy('order');
                    set_land(sorted);
                    setHomi(sorted)

                    // [0].items[0].extra_data
                    // let fs = response.data[0].items[1].extra_data;
                    //  console.log("AA!! ",JSON.parse(fs))

                    const basket = await GetBasket();

                    //---------------------------- sync local basket with api basket ----------------------------
                    // if(basket.data.items &&  basket.data.items.length>0){
                    //     let maped = basket.data.items.map(item=>{
                    //         return {count:item.quantity,product:item.product}
                    //     })
                    //     setBasket(maped)
                    //     localStorage.setItem("basket",JSON.stringify(maped))
                    // }else {
                    //     //empty
                    //     setBasket([])
                    //     localStorage.setItem("basket",JSON.stringify([]))
                    // }

                    //------------------------------------------------------------------------------------

                    if(basket.data.merchant && basket.data.merchant.uid  !== metId){
                        // console.log("حذف")
                        set_existBasket(basket.data.merchant.uid)
                        set_showModal(true)
                    }
                }
            }catch (e) {
                console.error(e)
                set_spin(false)
            }
    }

    const getRedirectData = async (merId)=> {
        const response = await StoreOnlineData(merId);
        // console.log("Dart : ", response.data);
        if (response.data.length > 0) {
            let sorted = response.data.sortBy('order');
            set_land(sorted);
        }
        set_merchantId(merId)
    }

    const back = () =>{
        // history.push(`/store-detail/${merchantId}`)
        history.push(`/home`)
    }

    const removeBasket = ()=>{
    localStorage.removeItem("basket");
    DeleteBasket()
    setBasket([])
    set_showModal(false)
    }

    const redirectToMerchantBasket = ()=>{
        history.push(`/online-store/${existBasket}`)
        getRedirectData(existBasket)
        set_showModal(false)
    }

    const SingleBanner = ({cats,merchantId})=>{
        return(
            <img style={{
                width: "100%",
                padding: "0 8px",
                margin: "0 0 10px 0",
            }} src={cats} alt=""/>
        )
    }


    const LinkDispatcher = (link,obj) => {
        switch (link) {
            case 'mall_campaigns':
                history.push('/festivals')
                break;
            case 'mall_campaign_details':
                history.push(`/festival-detail/${obj.link_to_uid}`,{festival:{uid:obj.link_to_uid}})
                break;
            case 'my_rewards':
                history.push('/reward')
                break;
            case 'mall_merchant_details':
                history.push(`/store-detail/${obj.link_to_uid}`,{store:{uid:obj.link_to_uid}})
                break;
            case 'merchant_online_store':
                if(obj.link_to_uid){
                    history.push('/online-store/'+obj.link_to_uid)
                }
                break;
            case 'checkin':
                history.push('/scan')
                break;
            case 'merchant_product':
                let replace = obj.link_to_uid.replace(/'/g, '"');
                let parsedPay =JSON.parse(replace);
                if(parsedPay.merchant_uid && parsedPay.product_uid){
                    history.push(`/online-store-product/${parsedPay.merchant_uid}/${parsedPay.product_uid}`)
                }
                break;
            case 'merchant_category_without_subcategory':
                history.push('/store')
                break;
            case 'mall_food_court':
                history.push('/store',{catLink:{uid:obj.link_to_uid}})
                break;
            case 'credit_package':
                history.push('/reward')
                break;
            case 'mall_parking':
                history.push('/store')
                break;
            case 'mall_event_details':
                history.push(`/event-detail/${obj.link_to_uid}`,{event:{uid:obj.link_to_uid}})
                break;
            case 'merchant_menu':
                history.push(`/menu/${obj.link_to_uid}`,{event:{uid:obj.link_to_uid}})
                break;
            case 'in_app_page':
                history.push("/"+obj.link_to_uid,{obj:obj})
                break;
            case 'live':
                livePreview(obj)
                break;
            case 'call_center':
                document.location.href="tel:"+obj.link_to_uid;
                break;
            case 'chat':
                let local_user = localStorage.getItem("user")
                let user_obj = JSON.parse(local_user)
                let new_topic = obj.link_to_uid.replace("REPLACE",user_obj.uid)
                history.push(`/chat/${new_topic}`)
                break;
            default:
                console.log("default")
        }
    }


    const livePreview = (obj)=>{
        window.open(obj.link_to_uid, "_blank") //t
    }

    const [spin,set_spin] = useState(false)


    return(
        <div>


            <>
                {resp?<div className="home-container-res">
                    <ShopResponsive merchant={metId} homi={homi} LinkDispatcher={LinkDispatcher}/>
                </div>:null}

                {!resp?<div className="store-online-container" style={{paddingBottom:70}}>
                    <Rodal
                        customStyles={{ height: 'auto', bottom: 'auto', top: '50%', transform: 'translateY(-50%)',width:'300px'}}
                        animation={"zoom"}
                        closeMaskOnClick={false}
                        visible={showModal} onClose={()=>set_showModal(false)}>
                        <div className="remove-basket-confirm">
                            <br/>
                            <span className="confirm-title">شما سبد خرید در فروشگاه دیگری دارید آیا مایل به حذف آن هستید ؟</span>
                            <div className="confirm-btns-row">
                                <span className="remove-basket" onClick={removeBasket}>بله</span>
                                <span className="redirect-basket" onClick={redirectToMerchantBasket}>خیر</span>
                            </div>
                        </div>
                    </Rodal>
                    {/*<br/><br/>*/}
                    {/*<OnlineSearch back={back} merchantId={merchantId}/>*/}
                    <DrShopHeader/>
                    {land && land.map(item=>{
                        switch (item.section_type) {
                            case "address_bar":
                                return <OnlineAddress merchantId={merchantId} />
                                break;
                            case "mall_products":
                                return(
                                    <ProductRegal item={item}/>
                                )
                                break;
                            case "product_category":
                                return (
                                    <CategoryRegal item={item}/>
                                )
                                break;
                            case 'campaign_list':
                                return (
                                    <CampaignList item={item}/>
                                )
                                break;
                            case 'service_section':
                                return (
                                    <ServiceSec item={item} LinkDispatcher={LinkDispatcher}/>
                                )
                                break;
                            case 'poll':
                                return (
                                    <PollSec item={item}/>
                                )
                                break;
                            case 'my_invoice_list':
                                return (
                                    <MyInvoiceList item={item}/>
                                )
                                break;
                            case 'multiple_banner':
                                return (
                                    <MultipleList item={item}/>
                                )
                                break;
                            case 'dual_bar':
                                return (
                                    <div className="block-pool" style={{order: 2}}>

                                        <div className="block-item-horizontal">
                                            <div className="wrapper" onClick={() => LinkDispatcher(item.items[0].link_to,item.items[0])}>
                                                {item.items[0] ?
                                                    <>
                                                        {/*<img src={item.items[0].image} alt=""/>*/}
                                                        <LazyImage type={'side'} src={item.items[0].image}/>
                                                        <span className="block-title">{item.items[0].title}</span>
                                                    </>
                                                    : null}
                                            </div>

                                            <div className="wrapper" onClick={() => LinkDispatcher(item.items[1].link_to,item.items[1])}>
                                                {item.items[1] ?
                                                    <>
                                                        {/*<img src={item.items[1].image} alt=""/>*/}
                                                        <LazyImage type={'side'} src={item.items[1].image}/>
                                                        <span className="block-title">{item.items[1].title}</span>
                                                    </>
                                                    : null}
                                            </div>
                                        </div>
                                    </div>
                                )
                                break;
                            case "shop_special_products":
                                return(
                                    <OnlineOff merchantId={merchantId} list={JSON.parse(item.items[0].extra_data)}/>
                                )
                                break;
                            case "slider":
                                return (<OnlineSlider merchant={merchantId} data={item.items}/>)
                                break;
                            case "shop_category_list":
                                return (<OnlineCategories cats={JSON.parse(item.items[0].extra_data)} merchantId={merchantId}/>);
                                break;
                            case 'single_bar':
                                return (
                                    <div key={item?.items[0]?.uid} className="single-bar" onClick={() => LinkDispatcher(item.items[0].link_to,item.items[0])} >
                                        <>
                                            {/*<img  src={item.items[0].image} alt=""/>*/}
                                            <LazyImage type={'banner'} src={item?.items[0]?.image}/>
                                            <span className="block-title">{item?.items[0]?.title}</span>
                                        </>
                                    </div>
                                )
                                break;
                            case "single_banner":
                                return (<SingleBanner cats={item?.items[0]?.image} merchantId={merchantId}/>);
                                break;
                            case 'video_content':
                                return (
                                    <VideoSec item={item}/>
                                )
                                break;
                            case 'button_list':
                                return (
                                    <div className="digi_badg_actions">
                                        {item.items.map(itemz => {
                                            return (
                                                <div key={itemz.uid} className="digi_badg_actions_item" onClick={()=>{ LinkDispatcher(itemz.link_to,itemz)}}>
                                                    <img src={itemz.image} alt="" style={{width: 48}}/>
                                                    <span>{itemz.title}</span>
                                                </div>
                                            )
                                        })}
                                    </div>
                                )
                                break;
                            case 'audio_content':
                                return (
                                    <AudioSec item={item}/>
                                )
                                break;
                            case "shop_category_with_featured_products":
                                return (
                                    <OnlineSwiper
                                        merchantId={merchantId}
                                        title={JSON.parse(item.items[0].extra_data).name}
                                        more={JSON.parse(item.items[0].extra_data).uid}
                                        list={JSON.parse(item.items[0].extra_data).selective_products}/>)
                                break;
                        }
                    })}
                    <Nav/>
                </div>:null}
            </>

            <Loading visible={spin}/>

        </div>
    )
}

export {OnlineStore};
